







































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

interface Memo {
  id: string;
  title: string;
  descriptions: Array<Description>;
}

interface Description {
  id: string;
  title: string;
  comments: Array<string>;
}
interface Td {
  id: string;
  title: Array<string>;
}

@Component
export default class MemoComponent extends Vue {

  @Prop()
  private msg!: string
  private color = false
  private isChange = false
  //private isChange0 = true
  //private isChange1 = false
  //private isChange2 = false
  //private isChange3 = false
  private isChanges = [true, false, false, false]

  yoshiko1 = "#!/bin/sh" + "\n" +
	"#chkconfig: 2345 90 10" + "\n" +
	"# description: WebSocket Server by Golang" + "\n" +
	"# Source function library." + "\n" +
	"if [ -f /etc/init.d/functions ] ; then" + "\n" +
	". /etc/init.d/functions" + "\n" +
	"elif [ -f /etc/rc.d/init.d/functions ] ; then" + "\n" +
	". /etc/rc.d/init.d/functions" + "\n" +
	"else" + "\n" +
	"exit 0" + "\n" +
	"fi" + "\n" +
	"" + "\n" +
	"#DAEMON=/usr/bin/stunnel" + "\n" +
	"DAEMON=/home/yoshiko/Work/go/src/github.com/toru.watanabe/chat/chat" + "\n" +
	"PROGNAME='basename $DAEMON'" + "\n" +
	"#prog=stunnel" + "\n" +
	"prog=chat" + "\n" +
	"" + "\n" +
	"start () {" + "\n" +
	"	cd /home/yoshiko/Work/go/src/github.com/toru.watanabe/chat" + "\n" +
	"	echo -n $\"Starting $prog: \"" + "\n" +
	"	#echo -n $\"Starting $PROGNAME: \"" + "\n" +
	"" + "\n" +
	"	# start daemon" + "\n" +
	"	daemon $DAEMON" + "\n" +
	"	RETVAL=$?" + "\n" +
	"	#echo" + "\n" +
	"	#[ $RETVAL = 0 ] && touch /var/lock/subsys/stunnel" + "\n" +
	"	[ $RETVAL -eq 0 ] && touch /var/lock/subsys/yoshiko" + "\n" +
	"	echo" + "\n" +
	"	return $RETVAL" + "\n" +
	"}" + "\n" +
	"" + "\n" +
	"stop () {" + "\n" +
	"	# stop daemon" + "\n" +
	"	echo -n $\"Stopping $prog: \"" + "\n" +
	"	killproc $DAEMON" + "\n" +
	"	RETVAL=$?" + "\n" +
	"	echo" + "\n" +
	"	#[ $RETVAL = 0 ] && rm -f /var/lock/subsys/stunnel" + "\n" +
	"	[ $RETVAL = 0 ] && rm -f /var/lock/subsys/yoshiko" + "\n" +
	"}" + "\n" +
	"" + "\n" +
	"restart() {" + "\n" +
	"	stop" + "\n" +
	"	start" + "\n" +
	"}" + "\n" +
	"" + "\n" +
	"case $1 in" + "\n" +
	"	start)" + "\n" +
	"		start" + "\n" +
	"		;;" + "\n" +
	"	stop)" + "\n" +
	"		stop" + "\n" +
	"		;;" + "\n" +
	"	restart)" + "\n" +
	"		restart" + "\n" +
	"		;;" + "\n" +
	"	status)" + "\n" +
	"		status $DAEMON" + "\n" +
	"		;;" + "\n" +
	"	*)" + "\n" +
	"	echo $\"Usage: $prog {start|stop|restart|status}\"" + "\n" +
	"	exit 1" + "\n" +
	"esac" + "\n" +
	"" + "\n" +
	"exit $RETVAL"

  yoshiko2 = "" + 
		"func main() {" + "\n" +
		"    // ルートへのリクエストを「gtplHandler」関数で処理する" + "\n" +
		"    http.HandleFunc(\"/\", gtplHandler)" + "\n" +
		"" + "\n" +
		"    // localhost:8080でサーバー処理開始" + "\n" +
		"    http.ListenAndServe(\":8080\", nil)" + "\n" +
		"}" + "\n"

  yoshiko3 = "" + 
		"func gtplHandler(w http.ResponseWriter, r *http.Request) {" + "\n" +
		"    // テンプレートをパースする" + "\n" +
		"    tpl := template.Must(template.ParseFiles(\"templates/sample.html\"))" + "\n" +
		"" + "\n" +
		"    // テンプレートに出力する値をマップにセット" + "\n" +
		"    values := map[string]string{" + "\n" +
		"        \"account\": \"user-0001\"," + "\n" +
		"        \"name\":    \"山田太郎\"," + "\n" +
		"        \"passwd\":  \"sample-pass\"," + "\n" +
		"    }" + "\n" +
		"" + "\n" +
		"    // マップを展開してテンプレートを出力する" + "\n" +
		"    if err := tpl.ExecuteTemplate(w, \"sample.html\", values); err != nil {" + "\n" +
		"        fmt.Println(err)" + "\n" +
		"    }" + "\n" +
		"}"


  yoshiko4 = "" + 
		"<!DOCTYPE html>" + "\n" +
		"<html>" + "\n" +
		"<head>" + "\n" +
		"	<title>{{.title}}</title>" + "\n" +
		"    <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\" />" + "\n" +
		"</head>" + "\n" +
		"<body>" + "\n" +
		"    <table>" + "\n" +
		"      <tr>" + "\n" +
		"        <td>アカウント名：</td>" + "\n" +
		"        <td>{{.account}}</td>" + "\n" +
		"      </tr>" + "\n" +
		"      <tr>" + "\n" +
		"        <td>お名前：</td>" + "\n" +
		"        <td>{{.name}}</td>" + "\n" +
		"      </tr>" + "\n" +
		"      <tr>" + "\n" +
		"        <td>パスワード：</td>" + "\n" +
		"        <td>{{.passwd}}</td>" + "\n" +
		"      </tr>" + "\n" +
		"    </table>" + "\n" +
		"</body>" + "\n" +
		"</html>"

  yoshiko5 = "" + 
		"type Handler interface {" + "\n" +
		"  ServeHTTP(ResponseWriter, *Request)" + "\n" +
		"}"

  yoshiko6 = "func Handle(pattern string, handler Handler) { DefaultServeMux.Handle(pattern, handler) }"

  memos:Array<Memo> = [
  {
    id: "1",
    title: "「initctl start/stop yoshiko」コマンドについて",
    descriptions: [
      {id: "1", title: "概要",
        comments: [
          "Go言語で作られたWebサーバを起動/停止する。",
          "このWebサーバは、さくらVPS上で動くものとするが、ApacheによるWebサーバとの競合を避けるために別のポート番号を使用する。"
        ]
      },
      {id: "2", title: "コマンドの定義",
        comments: [
          "「/etc/ini.d/yoshiko」の内容",
          this.yoshiko1
        ]
      },
    ]
  }, // end of id=1
  
  {
    id: "2",
    title: "Go言語による「Webサーバ」の構築について",
    descriptions: [
      {id: "1", title: "必要なパッケージ",
        comments: [
          "net/httpパッケージ",
          "html/templateパッケージ"
        ]
      },
      {id: "2", title: "net/httpパッケージの利用",
        comments: [
          "以下のmain()関数の例のように、http.HandlerFunc()関数やhttp.ListenAndServ()関数等を使用する。",
          "main()関数の例",
          this.yoshiko2]
      },
      {id: "3", title: "html/templateパッケージの利用",
        comments: [
          "以下のgtplHandler()関数の例のように、template.Must()関数やtemplate.ParseFiles()関数やtemplate.ExecuteTemplatev()関数等を使用する。",
          "gtplHandler()関数の例",
          this.yoshiko3,
          "sampl.htmlファイルの例",
          this.yoshiko4,
        ]
      },
      {id: "4", title: "http.Handlerとは",
        comments: [
          "http.Handlerとはインターフェイスでり、ServeHTTP関数を持つ。",
          "ServeHTTP関数は、端末からHTTPリクエストを受信してレスポンスを返すことを責務とする。",
          "Handlerインターフェイス: ",
          this.yoshiko5,
        ]
      },
      {id: "5", title: "http.Handleとは",
        comments: [
          "http.Handleは関数である。",
          "http.Handle関数は、以下のように、表示するURLと、URLに対応するhttp.HandlerをDefaultServeMux に登録する関数である。",
          "http.Handle関数: ",
          this.yoshiko6,
        ]
      },
    ]
  }, // end of id=2

  {
    id: "3",
    title: "Go言語とFyneによる「Webクライアント」の構築について",
	descriptions: [
		{id: "1", title: "必要なパッケージ",
        comments: [
			"fyne.io/fyne",
			"fyne.io/fyne/app",
			"fyne.io/fyne/widget",
			"fyne.io/fyne/theme",
        ]
      },
      {id: "2", title: "日本語フォント",
        comments: [
          "環境変数「FYNE_FONT」を以下の例のように設定する。",
          "C:\\Windows\\Fonts\\YuGothM.ttc"]
      },
    ]
  }, // end of id=3

  ] // end of memos
  

  /** ライフサイクルフック */
  public created() {
    //this.albums = [this.album_2, this.album_1];
    //this.firstImage();
  }
  
  public onClick(n: number) {
    for (let i=0; i<this.isChanges.length;i++) {
      this.isChanges[i] = false
    }
    this.isChanges[n] = true
	window.console.log("onClick() 1.n: " + n)
  }

}

